import Vue from "vue";
import store from "@/store/"
import Router from "vue-router";
import config from "../const/config";

//----------------
// 画面
//----------------
import Login from "@/views/Login";
import Home from "@/views/Home";
import WorkRegist from "@/views/WorkRegist";
import WorkCalendar from "@/views/WorkCalendar";
import ApplicationRegist from "@/views/ApplicationRegist";
import ApplicationHistory from "@/views/ApplicationHistory";
import Approval from "@/views/Approval";
import ApprovalHistory from "@/views/ApprovalHistory.vue";
import AttendanceCheck from "@/views/AttendanceCheck";
import WorkState from "@/views/WorkState";

import Manager_Login from "@/views/manager/Login";
import Manager_Home from "@/views/manager/Home";
import Manager_WorkRegist from "@/views/manager/WorkRegist";
import Manager_WorkCalendar from "@/views/manager/WorkCalendar";
import Manager_ApplicationRegist from "@/views/manager/ApplicationRegist";
import Manager_Approval from "@/views/manager/Approval";
import Manager_ApplicationHistory from "@/views/manager/ApplicationHistory.vue";
import Manager_ApprovalHistory from "@/views/manager/ApprovalHistory.vue";
import Manager_MailResend from "@/views/manager/MailResend";
import Manager_WorkSummary from "@/views/manager/WorkSummary";
import Manager_AttendanceCheck from "@/views/manager/AttendanceCheck";
import Manager_ProxyApplication from "@/views/manager/ProxyApplication";
import Manager_WorkState from "@/views/manager/WorkState";
import Manager_SubstituteHolidayManage from "@/views/manager/SubstituteHolidayManage";

Vue.use(Router);
const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      component: Login,
    },
    {
      path: "/Home",
      name: "Home",
      component: Home,
    },
    {
      path: "/WorkRegist",
      name: "WorkRegist",
      component: WorkRegist,
    },
    {
      path: "/WorkCalendar",
      name: "WorkCalendar",
      component: WorkCalendar,
    },
    {
      path: "/ApplicationRegist",
      name: "ApplicationRegist",
      component: ApplicationRegist,
    },
    {
      path: "/Approval",
      name: "Approval",
      component: Approval,
      meta: {
        authManagerAdminOnly: true,
      }
    },
    {
      path: "/ApplicationHistory",
      name: "ApplicationHistory",
      component: ApplicationHistory,
    },
    {
      path: "/ApprovalHistory",
      name: "ApprovalHistory",
      component: ApprovalHistory,
      meta: {
        authManagerAdminOnly: true,
      }
    },
    {
      path: "/AttendanceCheck",
      name: "AttendanceCheck",
      component: AttendanceCheck,
    },
    {
      path: "/WorkState",
      name: "WorkState",
      component: WorkState,
    },
    {
      path: "/manager",
      name: "manager_Login",
      component: Manager_Login,
    },
    {
      path: "/manager/Home",
      name: "manager_Home",
      component: Manager_Home,
    },
    {
      path: "/manager/WorkRegist",
      name: "manager_WorkRegist",
      component: Manager_WorkRegist,
    },
    {
      path: "/manager/WorkCalendar",
      name: "manager_WorkCalendar",
      component: Manager_WorkCalendar,
    },
    {
      path: "/manager/ApplicationRegist",
      name: "manager_ApplicationRegist",
      component: Manager_ApplicationRegist,
    },
    {
      path: "/manager/Approval",
      name: "manager_Approval",
      component: Manager_Approval,
      meta: {
        authManagerAdminOnly: true,
      }
    },
    {
      path: "/manager/ApplicationHistory",
      name: "manager_ApplicationHistory",
      component: Manager_ApplicationHistory,
    },
    {
      path: "/manager/ApprovalHistory",
      name: "manager_ApprovalHistory",
      component: Manager_ApprovalHistory,
      meta: {
        authManagerAdminOnly: true,
      }
    },
    {
      path: "/manager/MailResend",
      name: "manager_MailResend",
      component: Manager_MailResend,
      meta: {
        authManagerAdminOnly: true,
      }
    },
    {
      path: "/manager/WorkSummary",
      name: "manager_WorkSummary",
      component: Manager_WorkSummary,
      meta: {
        authManagerAdminOnly: true,
      }
    },
    {
      path: "/manager/AttendanceCheck",
      name: "manager_AttendanceCheck",
      component: Manager_AttendanceCheck,
    },
    {
      path: "/manager/ProxyApplication",
      name: "manager_ProxyApplication",
      component: Manager_ProxyApplication,
      meta: {
        authManagerAdminOnly: true,
      }
    },
    {
      path: "/manager/WorkState",
      name: "manager_WorkState",
      component: Manager_WorkState,
    },
    {
      path: "/manager/SubstituteHolidayManage",
      name: "manager_SubstituteHolidayManage",
      component: Manager_SubstituteHolidayManage,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // console.dir(from);
  // --- 該当するページがないURLを叩いた場合
  if (to.matched.length <= 0) {
    // ホーム画面へリダイレクト
    if (to.fullPath.indexOf('/manager/') > -1) {
      next({
        path: config.PAGES.MANAGER_HOME,
      });
    } else {
      next({
        path: config.PAGES.HOME,
      });
    }
  }
  // --- 権限チェック
  if (to.matched.some(record => record.meta.authManagerAdminOnly)) {
    // 権限区分が「システム管理者」または「部署管理者」のみOK
    if (store.state.system_authority_type != 1 && store.state.system_authority_type != 2) {
      // 表示対象外権限 -> ホーム画面へリダイレクト
      console.debug("This user isnot manager.");
      if (to.fullPath.indexOf('/manager/') > -1) {
        next({
          path: config.PAGES.MANAGER_HOME,
        });
      } else {
        next({
          path: config.PAGES.HOME,
        });
      }
    }
  }
  // --- ログインチェック
  if (to.fullPath != config.PAGES.LOGIN && to.fullPath != config.PAGES.MANAGER_LOGIN) {
    if (store.state.user_id == null || store.state.user_id.length <= 0) {
      // ログイン画面へリダイレクト(移動先を基に判定)
      if (to.fullPath.indexOf('/manager/') > -1) {
        next({
          path: config.PAGES.MANAGER_LOGIN,
        });
      } else {
        next({
          path: config.PAGES.LOGIN,
        });
      }
    }
  }
  next();
});

export default router;
